import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=01f5be73&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=01f5be73&prod&lang=scss"
import style1 from "./LandingPage.vue?vue&type=style&index=1&id=01f5be73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5be73",
  null
  
)

export default component.exports